import ShipmentTransactionsList from "./ShipmentTransactionsList";

export default ShipmentTransactionsList;
